// Hostname-aware store routing.
// On the public store domain(s) the store lives at the site root ("/");
// everywhere else (internal panel / preview / emergent.host) it lives under "/store".
import { STORE_HOSTS } from "@/lib/api";

export const isStoreHost =
  typeof window !== "undefined" && STORE_HOSTS.includes(window.location.hostname);

export const STORE_BASE = isStoreHost ? "" : "/store";

// Build a store route path: sp() -> home, sp("/search") -> "/search" or "/store/search".
export const sp = (p = "") => {
  const path = p && !p.startsWith("/") ? "/" + p : p;
  return STORE_BASE + path || "/";
};
